import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "..//..//assets/styles/local/AddProduct.css";
import { SketchPicker } from "react-color";
import {
  addStockColorCode,
  deleteStockColor,
} from "../../redux/actions/action";
import plusDottedIcon from "../../assets/icons/plus-dotted-icon.svg";

const StockColorPickers = ({ onUpdateColor, index, productcolor }) => {
  const dispatch = useDispatch();
  const [selectedColor, setSelectedColor] = useState(productcolor || "");
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);
  const recentStockColors = useSelector(
    (state) => state.user.recentStockColors
  );

  const handleColorChange = (color) => {
    setSelectedColor(color.hex);
  };

  const handleAddColor = () => {
    if (selectedColor) {
      dispatch(deleteStockColor(0));
      onUpdateColor(index, {
        target: { name: `productcolor-${index}`, value: selectedColor },
      });
      dispatch(addStockColorCode(selectedColor));
    }
    setShowPicker(false);
  };

  const handleClickOutside = (event) => {
    if (pickerRef.current && !pickerRef.current.contains(event.target)) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  return (
    <div
      ref={pickerRef}
      className="d-flex justify-content-center align-content-center">
      <div
        className="products-and-parts-color-picker-color products-and-parts-plus-dotted-icon-centered"
        style={{ backgroundColor: productcolor, top: "67%" }}></div>
      {!productcolor && (
        <img
          src={plusDottedIcon}
          alt="Plus Icon"
          className="products-and-parts-plus-dotted-icon "
          onClick={() => setShowPicker(true)}
        />
      )}
      <input
        type="text"
        className="products-and-parts-stock-inputs products-and-parts-color-input ps-4 cursor-pointer"
        name="productcolor"
        onFocus={() => setShowPicker(true)}
        readOnly
      />
      <div className="d-flex flex-column align-items-center justify-content-center color-picker">
        {showPicker && (
          <SketchPicker
            presetColors={recentStockColors}
            color={selectedColor}
            onChange={handleColorChange}
          />
        )}
        {selectedColor && showPicker && (
          <button
            onClick={handleAddColor}
            style={{
              padding: "10px 20px",
              backgroundColor: '#00246A',
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}>
            Add
          </button>
        )}
      </div>
    </div>
  );
};

export default StockColorPickers;
